(() => {
  const offerText = document.currentScript?.dataset.candleOffer;
  if (!offerText) return;
  const selector = '[data-label-id="100227"]';
  const update = (label) => {
    const text = label.querySelector('.pl-text');
    if (text && text.textContent !== offerText) text.textContent = offerText;
  };
  document.querySelectorAll(selector).forEach(update);
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      const target = record.target instanceof Element
        ? record.target
        : record.target.parentElement;
      const label = target?.closest(selector);
      if (label) update(label);
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches(selector)) update(node);
        node.querySelectorAll(selector).forEach(update);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
